import { consultantSharedStyles, profileSharedStyles } from '../shared/styles';
import { BORDER, createAdminPageStyles, MUTED, NAVY, TEXT } from '../style';

export const useStyles = createAdminPageStyles({
  ...consultantSharedStyles,
  ...profileSharedStyles,
  roleTag: {
    display: 'inline-flex',
    alignItems: 'center',
    borderRadius: 6,
    padding: '4px 10px',
    fontFamily: 'Poppins',
    fontSize: 13,
    fontWeight: 600,
    background: '#E3D7F5',
    color: '#5B3A8C',
  },
  beneficiariesToolbar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 16,
    marginBottom: 20,
    flexWrap: 'wrap',
    '& .MuiFormControlLabel-label': {
      fontFamily: 'Poppins',
      fontSize: 14,
      color: TEXT,
    },
  },
  beneficiariesSearch: {
    width: 320,
    maxWidth: '100%',
    '& .MuiOutlinedInput-root': {
      borderRadius: 8,
      fontFamily: 'Poppins',
      fontSize: 14,
      minHeight: 44,
      background: '#FFFFFF',
    },
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: BORDER,
    },
  },
  countCell: {
    textAlign: 'center',
  },
  badgeList: {
    display: 'flex',
    flexWrap: 'nowrap',
    alignItems: 'center',
    gap: 8,
  },
  overflowBadge: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    minWidth: 32,
    height: 28,
    padding: '0 8px',
    borderRadius: 5,
    border: `1px solid ${BORDER}`,
    background: '#FFFFFF',
    color: TEXT,
    fontFamily: 'Poppins',
    fontSize: 13,
    fontWeight: 600,
    lineHeight: 1,
    whiteSpace: 'nowrap',
  },
  beneficiaryCell: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: 2,
  },
  beneficiaryName: {
    padding: 0,
    border: 'none',
    background: 'transparent',
    color: NAVY,
    fontFamily: 'Poppins',
    fontSize: 15,
    fontWeight: 700,
    lineHeight: 1.4,
    textAlign: 'left',
    cursor: 'pointer',
    '&:hover': {
      textDecoration: 'underline',
    },
  },
  beneficiaryEmail: {
    color: MUTED,
    fontFamily: 'Poppins',
    fontSize: 13,
    fontWeight: 400,
    lineHeight: 1.4,
  },
  tableFooter: {
    display: 'flex',
    justifyContent: 'flex-start',
    marginTop: 16,
  },
  reassignBtn: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 8,
    padding: '12px 18px',
    background: '#FFFFFF',
    border: `1.5px solid ${BORDER}`,
    borderRadius: 10,
    fontFamily: 'Poppins',
    fontSize: 14,
    fontWeight: 600,
    color: TEXT,
    cursor: 'pointer',
    '&:hover': {
      background: '#F7F8FB',
    },
    '&:disabled': {
      opacity: 0.5,
      cursor: 'not-allowed',
    },
    '& svg': {
      display: 'block',
    },
  },
});
